import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { initializeGTM } from "./utils/gtm.ts";
import * as Sentry from "@sentry/react";

initializeGTM();

Sentry.init({
  dsn: "https://6c912e90ba9b61d6340a9f0e2f6302ac@o55209.ingest.us.sentry.io/4508964708286464",
  tracesSampleRate: 0.0,
  integrations: [Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false, maskAllInputs: false })],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
